import eventReducer from "./reducers";

export default eventReducer;